import Settings from './Settings'
import Group from './Profile/Group'
import Profile from './Profile'
import Reports from './Reports'
import Lessons from './List/Lessons'
import Lesson from './Profile/Lesson'
import AddLesson from './Add/Lesson'
import List from './List'
import Add from './Add'
import Wrapper from './Wrapper'
import Storage from './Storage'
import HomeworkCalendar from './Homework/Puzzle/Calendar'
import HomeworkCreate from './Homework/Create'
import StaticPage from './Static'
import Restore from './Restore'
import Activate from './Activate'

export default {
	Wrapper,
	Restore,
	StaticPage,
	Settings,
	Group,
	Profile,
	Reports,
	Lessons,
	Lesson,
	AddLesson,
	List,
	Add,
	Storage,
	HomeworkCalendar,
	HomeworkCreate,
	Activate
}
